import React, { useContext } from 'react'
import StoreContext from '../context/StoreContext'
import LineItem from './Line-Item'
import { Box } from 'theme-ui'
import { Styled } from '~/components/styled'
import { CartLine } from '~/types/cart-types'

const CartLineItems = () => {
  const { cart, isUpdatingLineItem } = useContext(StoreContext)

  const lines =
    (cart?.lines as { edges: Array<{ node: CartLine }> }) || undefined

  const renderEmpty = () => (
    <Box sx={{ height: '100%', textAlign: 'center' }} m={2} mt={[2, 3, 4]}>
      <Styled.h2>Your cart is empty.</Styled.h2>
    </Box>
  )

  return (
    <Box sx={{ height: '100%' }}>
      {lines?.edges.length
        ? lines.edges.map((edge: any) => {
            return (
              <LineItem
                isUpdating={edge.node.id === isUpdatingLineItem}
                key={edge.node.id}
                {...(edge.node as CartLine)}
              />
            )
          })
        : renderEmpty()}
    </Box>
  )
}

export default CartLineItems
